module.exports = __webpack_public_path__ + "media/images/front/inverted_triangle-58c28abe62cbd51503a44de1ebebfe68.svg";